import cloneDeep from 'lodash/fp/cloneDeep'
import {
  ADVISER_DATA_DUMP_DOWNLOADING,
  ADVISER_DATA_DUMP_DOWNLOAD_COMPLETE
} from './adviserDataDumpContainerActions.js'

const initialState = {
  downloading: false,
  downloaded: false
}

export default function (state = initialState, action) {
  var newState = cloneDeep(state)
  switch (action.type) {
    case ADVISER_DATA_DUMP_DOWNLOADING:
      newState.downloading = true
      newState.downloaded = false
      return newState
    case ADVISER_DATA_DUMP_DOWNLOAD_COMPLETE:
      newState.downloading = false
      newState.downloaded = true
      return newState
  }
  return state
}
